// extracted by mini-css-extract-plugin
export var attribution = "_cl-4";
export var authorName = "_cl-5";
export var quote = "_cl-3";
export var testimonial = "_cl-2";
export var trustedBy = "_cl-0";
export var trustedByLabel = "_cl-1";